import { IconFont } from '@byecode/ui/components/IconFont'
import chroma from 'chroma-js'
import styled, { css } from 'styled-components'

const MenuButton = styled(IconFont)`
    opacity: 0;
    margin-left: auto;
`

export const Line = styled.div.withConfig<{ color: string; hovered: boolean; showBar: boolean }>({
    shouldForwardProp: p => !['color', 'hovered', 'showBar'].includes(p)
})`
    touch-action: none;
    position: absolute;
    cursor: pointer;
    font-size: 12px;
    border-radius: 3px;
    overflow: hidden;
    ${({ color, hovered, showBar }) => {
        const isWhite = color ? chroma(color).hex() === chroma('#ffffff').hex() : true
        return css`
            background: ${isWhite ? 'var(--color-gray-100)' : color && chroma(color).luminance(0.9).hex()};

            ${hovered &&
            css`
                background: ${isWhite ? 'var(--color-gray-200)' : color && chroma(color).luminance(0.8).hex()};
                ${MenuButton} {
                    opacity: 1;
                }
            `}

            ${showBar &&
            css`
                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 3px;
                    background: ${isWhite ? 'var(--color-gray-500)' : color};
                }
            `}
        `
    }}
`

export const LineWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px 8px;
`

export const LineResizeHandle = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    cursor: ew-resize;
`

export const LineTitle = styled.span<{ isMobile: boolean }>`
    font-weight: 500;
    line-height: ${({ isMobile }) => (isMobile ? '14px' : '22px')};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    user-select: none;
`

export const LineContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`
